import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { useHomepageConfig } from '@/hooks/useHomepageConfig';
import { Editable } from '@/components/edit/Editable';

const DEFAULT_TESTIMONIALS = [
  { quote: 'The Casa Samba performance was an explosion of color, rhythm, and pure energy.', name: 'John', role: 'NCORE' },
  { quote: 'The air crackled with excitement as they spun, leaped, and swayed to the hypnotic music.', name: 'Pam', role: 'McDonalds' },
  { quote: "The entire experience resonated deep within me, leaving me feeling invigorated and inspired.", name: 'Shawn', role: 'Tulane University' },
];

export const HomeTestimonials = () => {
  const cfg = useHomepageConfig();
  const items = (Array.isArray(cfg?.testimonials) && cfg.testimonials.length) ? cfg.testimonials : DEFAULT_TESTIMONIALS;

  return (
    <section className="py-20 md:py-28 px-6" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <Editable
            as="h2"
            path="testimonialsHeading"
            fallback={cfg?.testimonialsHeading || 'What They Say'}
            className="text-3xl md:text-5xl font-black text-foreground uppercase tracking-wide"
          />
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {items.map((t, idx) => (
            <motion.div
              key={(t.name || 'testimonial') + idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.12 }}
              className="p-8 rounded-2xl bg-white/5 backdrop-blur-md border border-white/15 shadow-xl shadow-black/30 flex flex-col"
              data-testid={`testimonial-${idx}`}
            >
              <Quote className="w-8 h-8 text-primary mb-4" />
              <Editable
                as="p"
                path={`testimonials.${idx}.quote`}
                fallback={t.quote}
                className="text-foreground/85 leading-relaxed flex-1"
                multiline
              />
              <div className="mt-6 pt-4 border-t border-border/50">
                <Editable
                  as="p"
                  path={`testimonials.${idx}.name`}
                  fallback={t.name}
                  className="font-bold text-foreground"
                />
                <Editable
                  as="p"
                  path={`testimonials.${idx}.role`}
                  fallback={t.role}
                  className="text-sm text-primary"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeTestimonials;
